/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ErrorTypeEnum {
    SYSTEM_ERROR = 'system_error',
    CLIENT_ERROR = 'client_error',
    EXTERNAL_ERROR = 'external_error',
    VALIDATION_ERROR = 'validation_error',
    DATA_INTEGRITY_ERROR = 'data_integrity_error',
    MALICIOUS_CONTENT_ERROR = 'malicious_content_error',
}
